
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError} from 'rxjs/operators';
import { EcaSecurityAuthenticationService } from './../../services/security-authentication/security-authentication.service';
import { Injectable, inject } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class EcaAuthenticatedUserResolver  {
  private _ecaSecurityAuthenticationService = inject(EcaSecurityAuthenticationService);
  private router = inject(Router);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this._ecaSecurityAuthenticationService.getUser().pipe(catchError(() => {
      this.router.navigateByUrl('/denied');
      return observableThrowError('denied');
    }));
  }
}
